<template>
  <v-container id="status-report" fluid tag="section">
    <div class="md-layout">

      <FilterForm
        :filterForm="filterForm"
      />
      <div class="table-layout mt-7">
        <v-card v-if="noData" class="pb-2">
          <common-no-result />
        </v-card>
        <contact-status-count-table
          v-else
          :typeHeaderContactStatus="typeHeaderContactStatus"
          :contactStatusList="contactStatusList"
          :contactStatusTotal="contactStatusTotal"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import TokenService from '../../../../helpers/token';
import ContactStatusCountTable from './components/ContactStatusCountTable';
import FilterForm from './components/FilterForm';
import * as moment from 'moment'

import RepositoryFactory from '../../../../repositories/RepositoryFactory';
const ReportRepository = RepositoryFactory.get('report');

export default {
  components: {
    ContactStatusCountTable,
    FilterForm
  },
  data() {
    return {
      filterForm: {
        storeId: 0,
        dateRange: {
          startDate: moment().startOf('days').format('YYYY-MM-DD'),
          endDate: moment().endOf('days').format('YYYY-MM-DD'),
        },
        departmentId: '',
        departmentIds: []
      },
      typeHeaderContactStatus: [],
      contactStatusList: [],
      contactStatusTotal: [],
      noData: false
    };
  },
  created() {
    this.getCountContactStatusList();
    Bus.$on('status-report-filter-thpt', filterForm => {
      this.filterForm = filterForm;
      this.getCountContactStatusList();
    });
  },
  methods: {
    changeStoreStock() {
      this.getCountContactStatusList();
    },
    async getCountContactStatusList() {
      const loading = this.$loading.show();
      const params = {
        storeId: this.filterForm.storeId,
        startDateTime: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
        endDateTime: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
        departmentIds: this.filterForm.departmentIds,
        schoolLevelIds: [2]
      };

      // if (!this.isManager()) {
      //   if (this.filterForm.departmentId == 0 ) {
      //     this.filterForm.departmentId = '';
      //   }
      //   const dataUser = TokenService.getUser() || {};
      //   params.departmentId = dataUser.departmentId;
      // }
      const response = await ReportRepository.reportByContactStatus(params);
      loading.hide();
      if (response.success) {
        const typeHeaderContactStatus = [];
        const contactStatusList = [];
        const contactStatusTotal = [];
        if (_.isEmpty(response.data)) {
          this.noData = true
        } else {
          this.noData = false
          _.get(response, 'data', []).forEach(contactStatus => {
            if(contactStatus.type !== 'T0' && contactStatus.type !== 'C0'){
              typeHeaderContactStatus.push({
                name: contactStatus.type,
                colspan: _.get(contactStatus, 'data', []).length || 1
              });

              let percentageTotal = 0
              let countItemsTotal = 0

              _.get(contactStatus, 'data', []).forEach(data => {
                if(contactStatus.type !== 'T0' && contactStatus.type !== 'C0') {
                  contactStatusList.push({
                    type: contactStatus.type,
                    id: _.get(data, 'id', 0),
                    countItems: _.get(data, 'countItems', 0),
                    name: _.get(data, 'name', 0),
                    percentage: (+_.get(data, 'percentage', 0)).toFixed(2)
                  });
                  percentageTotal += +data.percentage
                  countItemsTotal += +data.countItems
                }
              });
              contactStatusTotal.push({
                type: contactStatus.type,
                percentage: percentageTotal.toFixed(2),
                countItems: countItemsTotal
              })
            }
          });

          this.typeHeaderContactStatus = typeHeaderContactStatus;
          this.contactStatusList = contactStatusList;
          this.contactStatusTotal = contactStatusTotal
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
    },
  }
};
</script>
